import { useId } from 'react';
import { joinClasses } from 'utils/componentStyles/style.utils';
import '../../assets/userMenu.scss';

/**
 * A shared User Menu section whose colors follow the owning feature's appearance.
 *
 * @param {object} props
 * @param {import('react').ReactNode} [props.icon] Decorative icon beside the title.
 * @param {string} props.title The section heading.
 * @param {import('react').ReactNode} [props.description] One muted line under the heading.
 * @param {import('react').ReactNode} [props.actions] Controls at the end of the header row.
 * @param {string} [props.className] Extra classes for the section.
 * @param {import('react').ReactNode} props.children The section body.
 */
const UserMenuPanel = ({ icon, title, description, actions, className, children }) => {
  const headingId = useId();

  return (
    <section className={joinClasses('user-menu-panel', className)} aria-labelledby={headingId}>
      <header className="user-menu-panel-header">
        <div className="user-menu-panel-heading">
          {icon ? (
            <span className="user-menu-panel-icon" aria-hidden="true">
              {icon}
            </span>
          ) : null}
          <div>
            <h2 id={headingId} className="user-menu-panel-title">
              {title}
            </h2>
            {description ? <p className="user-menu-panel-description">{description}</p> : null}
          </div>
        </div>
        {actions ? <div className="d-flex flex-wrap gap-2">{actions}</div> : null}
      </header>
      <div className="user-menu-panel-body">{children}</div>
    </section>
  );
};

export default UserMenuPanel;
